import { compose, lifecycle, withState } from 'recompose'
import * as Sentry from '@sentry/browser'

const errorBoundary = () =>
  compose(
    withState('error', 'setError', null),
    lifecycle({
      componentDidCatch (error, info) {
        Sentry.captureException(error, {
          extra: info
        })

        this.props.setError(error)
      }
    })
  )

export default errorBoundary
